import Vue from "vue";
// Firebase and the modules to be used.
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

export default {
  state: {
    user: {},
    userRestaurants: [],
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setUserRestaurants(state, payload) {
      state.userRestaurants = payload;
    },
    updateUser(state, payload) {
      if (payload.email) {
        state.user.email = payload.email
      }
      if (payload.id) {
        state.user.id = payload.id
      }
      if (payload.favLang) {
        state.user.favLang = payload.favLang
      }
      if (payload.restaurants) {
        state.user.restaurants = payload.restaurants
      }
    }
  },
  actions: {
    // TODO At some point add email confirmation chain with firebase
    signUserUp({commit}, payload) {
      commit('setLoading', true);
      commit('clearError');
      const user = {
        id: '',
        favLang: '',
        email: '',
      };

      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
          data => {
            user.id = data.user.uid;
            user.favLang = Vue.i18n.translate('locale');
            user.email = data.user.email;

            // TODO not sure if this should be done here, there's wasn't an email confirmation yet.
            // Store new user as new entry in the DB
            firebase.firestore().collection('users').doc(user.id)
              .set(user)
              .then(
                // Change user data state before redirecting to restaurant creation page.
                () => {
                  commit("setUser", user);
                  commit('setLoading', false);
                }
              )
          }
        )
        .catch(
          error => {
            commit('setLoading', false);
            commit('setError', error);
          }
        );
    },
    signUserIn({commit, actions}, payload) {
      commit('setLoading', true);
      commit('clearError');

      const userRestaurants = [];
      const user = {
        id: '',
        favLang: '',
        email: '',
      };

      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(
          data => {
            user.favLang = Vue.i18n.translate('locale');
            user.id = data.user.uid;
            user.email = data.user.email;
          }
        )
        // Load user restaurants:
        .then(
          () => {
            firebase.firestore().collection("restaurants").where('ownerUid', '==', user.id).get()
              .then(
                (querySnapshot) => {
                  if (!querySnapshot.empty) {
                    querySnapshot.forEach((doc) => {
                      const data = doc.data();
                      userRestaurants.push({
                        id: doc.id,
                        ownerUid: data.ownerUid,
                        isActive: data.isActive
                      });
                    });
                  }
                  commit("setUser", user);
                  commit("setSelectedLang", user.favLang);
                  commit("setUserRestaurants", userRestaurants);
                  commit('setLoading', false);
                })
          }
        )
        .catch(
          error => {
            commit('setLoading', false);
            commit('setError', error);
          }
        )
    },
    autoSignIn({commit}, payload) {
      commit('setUser', {
        id: payload.uid,
        favLang: payload.favLang,
        restaurants: []
      })
    },
    fetchUserData({commit, getters}) {
      commit('setLoading', true);
      const user = getters.user;

      firebase.firestore().collection("users").doc(user.id).collection("restaurants").get()
        .then(function (querySnapshot) {
          const userRestaurants = [];
          // if user has restaurants to load
          if (!querySnapshot.empty) {
            querySnapshot.forEach((doc) => {
              const data = doc.data();
              userRestaurants.push({
                id: doc.id,
                isActive: data.isActive
              });
            });
          }
          // If user has no restaurants
          else {
            // Create a restaurant for the user
            firebase.firestore().collection("users").doc(user.id).collection("restaurants").add(
              { // Restaurant is active by default when the user registers
                isActive: true
              }).then(
              (doc) => {
                userRestaurants.push({
                  id: doc.id,
                  isActive: true
                });
              }
            )
          }
          commit('updateUser', {...user, restaurants: userRestaurants});
          commit('setLoading', false);
        }).catch(function (error) {
        console.log('Error getting documents: ', error);
      });
    },
    logout({commit}) {
      firebase.auth().signOut().then(
        () => {
          commit('setUser', null);
          commit('setUserRestaurants', null);
        }
      );

    }
  },
  getters:{
    user(state) {
      return state.user
    },
    userRestaurants(state) {
      return state.userRestaurants;
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/user/index.js